import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import BeforeAfterSlider from './BeforeAfterSlider';

export default function BeforeAfter() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/before-after')
      .then((res) => setProjects(Array.isArray(res.data) ? res.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;

  const visible = projects.filter((p) => p.images && p.images.length > 0);
  if (visible.length === 0) return null;

  return (
    <section className="before-after-section">
      <div className="container">
        <h2 className="section-title">Öncesi / Sonrası</h2>
        <div className="before-after-grid">
          {visible.map((project) => {
            const first = project.images[0];
            return (
              <div key={project.id} className="before-after-item">
                <BeforeAfterSlider before={first.before_image} after={first.after_image} />
                <div className="before-after-info">
                  {project.slug ? (
                    <h3>
                      <Link to={`/oncesi-sonrasi/${project.slug}`}>{project.title}</Link>
                    </h3>
                  ) : (
                    <h3>{project.title}</h3>
                  )}
                  {project.description && <p>{project.description}</p>}
                  {project.images.length > 1 && project.slug && (
                    <Link to={`/oncesi-sonrasi/${project.slug}`} className="ba-more-link">
                      Tüm görseller ({project.images.length}) →
                    </Link>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
